import { IJsonQueryLocation } from '../../../../api-models/common/json_query';
import { createGeoTagsManager } from '../../utils/createGeoTagsManager';

export const geoLocationTagsManager = createGeoTagsManager<IJsonQueryLocation>({
  jsonQueryKey: 'location',
  labelGetter: ({ geoTags, geoValue }) => geoTags.locations[geoValue.id] || 'Неизвестный адрес',
  id: 'geoLocation',
});
